module.exports = __webpack_public_path__ + "sz.svg?dee254bf0c34149f6764f432c6519f29";